import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

/**
 * Keeps variant-backed spec rows in sync with the selected variant.
 *
 * Uses the theme's event API (`ThemeEvents.variantUpdate` -> "variant:update"),
 * documented in assets/events.js. Variant metafields are NOT part of the variant
 * JSON payload carried by the event, so we read the freshly rendered values from
 * the section HTML the event provides (`event.detail.data.html`) and morph them in.
 */
class ProductSpecs extends HTMLElement {
  /** @type {AbortController} */
  #abortController = new AbortController();

  connectedCallback() {
    document.addEventListener(
      ThemeEvents.variantUpdate,
      /** @type {EventListener} */ (this.#onVariantUpdate),
      { signal: this.#abortController.signal }
    );
  }

  disconnectedCallback() {
    this.#abortController.abort();
  }

  /**
   * @param {import('@theme/events').VariantUpdateEvent} event
   */
  #onVariantUpdate = (event) => {
    const { data } = event.detail;
    if (!data?.html) return;

    // Track combined-listing product swaps; otherwise ignore updates for other products.
    if (data.newProduct) {
      this.dataset.productId = data.newProduct.id;
    } else if (data.productId && data.productId !== this.dataset.productId) {
      return;
    }

    const newSpecs = data.html.querySelector(
      `product-specs[data-block-id="${this.dataset.blockId}"]`
    );

    if (!newSpecs) return;

    morph(this, newSpecs, { childrenOnly: true });
  };
}

if (!customElements.get('product-specs')) {
  customElements.define('product-specs', ProductSpecs);
}
